import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProveedorComponent } from '../../shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { ProveedorService } from 'src/app/services/proveedor.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import * as _ from 'lodash';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
@Component({
  selector: 'app-docs-por-pagar-proveedores',
  templateUrl: './docs-por-pagar-proveedores.component.html',
  styleUrls: ['./docs-por-pagar-proveedores.component.scss'],
  providers: [SecurityService],
})
export class DocsPorPagarProveedoresComponent implements OnInit {
  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = '_RB_TIPO_VISTA_RESUMEN_';
  readonly RB_TIPO_VISTA_DETALLE: String = '_RB_TIPO_VISTA_DETALLE_';

  // Modales
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent;
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>();

  // Form
  formHeader: FormGroup;

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  private inputParams: any = null;
  proveedorSeleccionado: any = null;
  listaRegistros: any = null;
  abonosPorAplicar: any = null;
  totales: any = null;
  paginationContext: PaginationContext = new PaginationContext();
  loading: boolean = false;
  loaded: boolean = false;
  headerData: any = {};
  optionsTipoDoc: Array<any> = [];
  enableProveedorInputs: boolean = true;
  private currentPayload: any = null;

  // Utils
  private log: any;

  private resumen_currentPayload: any = null;
  resumen_paginationContext: PaginationContext = new PaginationContext();
  resumen_loading: boolean = false;
  resumen_listaMovimientos: Array<any> = null;
  resumen_listaMovimientosAll: Array<any> = null;
  resumen_totales: any = null;

  private detalle_currentPayload: any = null;
  detalle_loading: boolean = false;
  detalle_listaMovimientos: Array<any> = null;
  detalle_listaMovimientosAll: Array<any> = null;
  detalle_paginationContext: PaginationContext = new PaginationContext();
  detalle_totales: any = null;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private rutService: RutService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private fileDownloadService: FileDownloadService,
    private ProveedorService: ProveedorService,
    private datesService: DatesService,
    private tipoDTEService: TipoDTEService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('DOC-PAGADO-Y-POR-PAGAR-PROVEEDOR');
  }

  optionsTipoPago: Array<any> = [];

  ngOnInit() {
    // this.optionsTipoPago = [
    //   { value: "1", label: "Tipo Pago 1" },
    //   { value: "2", label: "Tipo Pago 2" },
    //   { value: "3", label: "Tipo Pago 3" },
    // ];
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10;
    this.detalle_paginationContext.RecordsByPage = 10;

    this.paginationContext.RecordsByPage = 10;
    this.createForms();
    this.loadTipoDoc();
    this.formChangesSubscriptions();
  }

  private loadTipoDoc() {
    // Tipos documentos
    this.tipoDTEService.GetByTipoDte(3, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsTipoDoc = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
      //this.setDefaultDoctoReferencia()
    });
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      rut: [''],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      listaTipoDoc: [[]],
      todosProveedores: [false],
      doc_por_pagar: [true],
      doc_pagados: [true],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rut')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutProveedor: string) => {
        this.modalSeleccionarProveedor.searchByRut(rutProveedor);
      });

    /********* MODAL PROVEEDOR *********/
    this.formHeader.get('todosProveedores').valueChanges.subscribe((todosProveedores: string) => {
      this.log('Todos change', todosProveedores);
      this.enableProveedorInputs = !todosProveedores;
    });
  }

  abrirModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show();
  }

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data;
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut);
    this.formHeader.get('rut').setValue(this.proveedorSeleccionado.rutFormato);
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null;
    this.clearProveeData();
  }
  clearProveeData() {
    this.clearContent();
    this.onProveedorChange.emit(null);
  }
  clearContent() {
    this.headerData = {};
    // this.formValidatorsService.reset(this.formHeader)
  }

  validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber);
    this.detalleBuscar(pageNumber);
  }

  /********* RESUMEN *********/
  resumenBuscar(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber;
    this.resumen_listaMovimientos = null;

    let valid: Boolean = true;

    if (!valid) return;

    const { listaTipoDoc } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
        cliente_proveedor_rut: this.proveedorSeleccionado ? this.proveedorSeleccionado.rut : 0,
        todosProveedores: this.proveedorSeleccionado ? false : true,
        pagado: this.formHeader.get('doc_por_pagar').value,
        porpagar: this.formHeader.get('doc_pagados').value,
        listaTipoDoc,
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1,
    };

    this.resumen_currentPayload = _.cloneDeep(inputParams);

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.ProveedorService.getObtenerDocPagadorYPorPagarProveedorResumen(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      this.resumen_listaMovimientosAll = registros;
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length;
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage); //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1;
      this.resumen_listaMovimientosAll.forEach((mov) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
      });

      this.showPageResumen(this.resumen_paginationContext.CurrentPage);
      this.calculateTotalesResumen();
      this.resumen_loading = false;
    });
  }

  resumenOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageResumen(context.RequestedPage);
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber;
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage;
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage);
  }

  calculateTotalesResumen() {
    this.resumen_totales = {
      total_monto: _.sumBy(this.resumen_listaMovimientosAll, 'monto'),
      total_pago: _.sumBy(this.resumen_listaMovimientosAll, 'abono'),
      total_saldo: _.sumBy(this.resumen_listaMovimientosAll, 'saldo'),
    };
  }

  // onPageChange(context: PaginationContext) {
  //   this.buscar(context.RequestedPage)
  // }

  detalleBuscar(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber;

    this.detalle_listaMovimientos = null;

    let valid: Boolean = true;

    if (!valid) return;
    const { listaTipoDoc } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
        cliente_proveedor_rut: this.proveedorSeleccionado ? this.proveedorSeleccionado.rut : 0,
        todosProveedores: this.proveedorSeleccionado ? false : true,
        pagado: this.formHeader.get('doc_por_pagar').value,
        porpagar: this.formHeader.get('doc_pagados').value,
        listaTipoDoc,
      },
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1,
    };

    this.detalle_currentPayload = _.cloneDeep(inputParams);

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.ProveedorService.getObtenerDocPagadorYPorPagarProveedorDetalle(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      this.detalle_listaMovimientosAll = registros;
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length;
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage); //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1;
      this.detalle_listaMovimientosAll.forEach((mov) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
      });

      this.showPageDetalle(this.detalle_paginationContext.CurrentPage);
      this.calculateTotalesDetalles();
      this.detalle_loading = false;
    });
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber;
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage;
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage);
  }

  calculateTotalesDetalles() {
    this.detalle_totales = {
      total_monto: _.sumBy(this.detalle_listaMovimientosAll, 'monto'),
      total_pago: _.sumBy(this.detalle_listaMovimientosAll, 'abono'),
      total_saldo: _.sumBy(this.detalle_listaMovimientosAll, 'saldo'),
    };
  }

  detalleOnPageChange(context: PaginationContext) {
    this.showPageDetalle(context.RequestedPage);
  }

  limpiarfiltros() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader.reset();
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_RESUMEN);
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get('todosProveedores').setValue(false);
    this.formHeader.get('doc_por_pagar').setValue(true);
    this.formHeader.get('doc_pagados').setValue(true);
    this.proveedorSeleccionado = null;
    this.detalle_listaMovimientos = null;
    this.resumen_listaMovimientos = null;
  }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));

    this.ProveedorService.getObtenerDocPagadorYPorPagarProveedorResumenExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].nombreArchivoExcel);
    });
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload);

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.ProveedorService.getObtenerDocPagadorYPorPagarProveedorDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      this.log('excel respuesta', respuesta);
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].nombreArchivoExcel);
    });

    // const inputParams = _.cloneDeep(this.detalle_currentPayload)
    // delete inputParams.cantidadRegistrosPorPagina
    // delete inputParams.paginaActual

    // inputParams.entidad.retornaExcel = type === 'XLS'

    // this.log('inputParams', JSON.stringify(inputParams))

    // this.saldoDocumentoService.obtenerDocumentoPorCobrarClienteDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
    //   const ok = respuesta !== null
    //   if (!ok) {
    //     this.messageRendererService.showErrors(mensajes)
    //     return
    //   }
    //   if (respuesta)
    //     this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].nombreArchivoExcel)
    // })
  }
}
